
import { TabStyles } from '@tableau/widgets';

import { cssClass, textEllipsis } from '../../style';

const rootClass = 'LinkedTaskCell';
const lineHeight: string = '20px';

export namespace LinkedTaskCellStyles {

  export const FlexShrinkZero = cssClass(rootClass, 'FlexShrinkZero', {
    flexShrink: 0
  });

  export const Wrapper = cssClass(rootClass, 'Wrapper', {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '10px',
  });

  export const CheckboxWrapper = cssClass(rootClass, 'CheckboxWrapper', {
    display: 'flex',
    marginLeft: '-12px',
    paddingRight: '12px'
  });

  export const ContentItem = cssClass(rootClass, 'Item', textEllipsis, {
    height: lineHeight,
    lineHeight: lineHeight,
  });

  export const ItemIcon = cssClass(rootClass, 'ItemIcon', {
    paddingRight: '6px',
    height: lineHeight,
    lineHeight: lineHeight,
  });

  export const TextWrapper = cssClass(rootClass, 'TextWrapper', {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  });

  export const InnerTextWrapper = cssClass(rootClass, 'InnerTextWrapper', {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  });

  export const ContentName = cssClass(rootClass, 'ContentName', {
    fontWeight: 'bold',
    paddingLeft: '3px',
  });

  export const Disabled = cssClass(rootClass, 'Disabled', {
    opacity: 0.6,
  });

  export const LinkButton = cssClass(rootClass, 'LinkButton', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderRadius: '1px',
    marginLeft: 'auto',
    height: lineHeight,
    width: lineHeight,
    border: '1px solid transparent',
    $nest: {
      '&:hover': {
        backgroundColor: TabStyles.Colors.F5
      },
      '&:active': {
        backgroundColor: TabStyles.Colors.F7,
      },
      '&:focus': {
        backgroundColor: TabStyles.Colors.F5,
        border: `1px solid ${TabStyles.Colors.Focus}`,
        boxShadow: `0 0 4px 0 ${TabStyles.Colors.Focus}`,
      }
    }
  });

  export const LinkImg = cssClass(rootClass, 'LinkImg', {
    height: '14px',
    width: '14px',
  });

  export const InfoIcon = cssClass(rootClass, 'InfoIcon', {
    height: '14px',
    margin: '3px 0 0 6px',
  });
}
